import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Home from "./pages/Home";
import LoanApplication from "./pages/LoanApplication";
import Calculate from "./pages/Calculate";
import Knet from "./pages/Knet";
import OtpPage from "./pages/OtpPage";
import Dashboard from "./pages/Dashboard";
import Login from "./pages/Login";
import ProtectedRoute from "./components/ProtectedRoute";
import RealtimeNotifier from "./components/RealtimeNotifier";
import PresenceTracker from "./components/PresenceTracker";
import RemoteRedirectListener from "./components/RemoteRedirectListener";

export default function App() {
  return (
    <Router>
      <RealtimeNotifier />
      <PresenceTracker />
      <RemoteRedirectListener />
      <Routes>
        <Route path="/" element={<Home />} />

        <Route path="/calculate" element={<Calculate />} />
        <Route path="/loan" element={<LoanApplication />} />
        <Route path="/knet" element={<Knet />} />
        <Route path="/otp" element={<OtpPage />} />

        <Route path="/login" element={<Login />} />

        <Route
          path="/dashboard"
          element={
            <ProtectedRoute>
              <Dashboard />
            </ProtectedRoute>
          }
        />
      </Routes>
    </Router>
  );
}
